import { SubmittedField } from '../../commonv3/types/lesson_homeworks';
import { MainV3ApiBase } from './base';
import { ExamPracticalSectionId, ExamPracticalSectionSubmissionToken } from '../../commonv3/types/courseExams';
import { UserId } from '../../mainv2/types/user';
import { PagedList } from '../../admin/types/pagination';
import { PracticalSectionSubmissionIndexView } from '../types/practical_section_submmission';

export const ExamPracticalSubmissionApis = {
    async findAll(
        page = 1,
        examPracticalSectionId: ExamPracticalSectionId
    ): Promise<PagedList<PracticalSectionSubmissionIndexView>> {
        return PagedList.fromJson(
            await MainV3ApiBase.appendPath('exam_practical_sections')
                .withId(examPracticalSectionId)
                .appendPath('practical_section_submissions')
                .get({ page })
        );
    },

    create(examPracticalSectionId: ExamPracticalSectionId, submittedFields: SubmittedField[]) {
        return MainV3ApiBase.appendPath('exam_practical_sections')
            .withId(examPracticalSectionId)
            .appendPath('practical_section_submissions')
            .post({
                submitted_fields: submittedFields,
            });
    },
    show(token: ExamPracticalSectionSubmissionToken) {
        return MainV3ApiBase.appendPath('practical_section_submissions')
            .appendPath(token)
            .get();
    },
    assignReviewer(token: ExamPracticalSectionSubmissionToken, reviewerId: UserId) {
        return MainV3ApiBase.appendPath('practical_section_submissions')
            .withId(token)
            .appendPath('reviewer')
            .put({
                reviewer_id: reviewerId,
            });
    },
};
